/**
 * Approved from back to send ISO format
 */
export function formatCustomDate(date: Date) {
	return date.toISOString()
}
